export const DatadogPrivacyClasses = {
  "dd-privacy-mask": "dd-privacy-mask",
  "dd-privacy-allow": "dd-privacy-allow",
  "dd-privacy-hidden": "dd-privacy-hidden",
  "dd-privacy-mask-user-input": "dd-privacy-mask-user-input",
};
